import styled from "styled-components";

export const Tag = styled.span<{
    requer_atencao?: boolean
    novo?: boolean
    marginTop: string
}>`
    width: 50%;
    height: 1rem;
    background-color: ${props => props.novo ? "var(--green)" : props.requer_atencao ? "var(--red)" : "var(--grey)"};
    border-radius: 2rem;
    margin-top: ${props => props.marginTop};
    position: absolute;
    left: 50%;
    transform: translate(-50%);
`